import React, { useEffect, useRef, useState } from 'react';
import { /*Button,*/ Col, Form, Row } from 'react-bootstrap';
import { PeriodicReportingType } from '../PeriodicReporting';
import { updateStatementByProjectIdAndStatementId } from 'lib/api_ts/periodicReportingApi';
import { useLocation } from 'react-router-dom-v5-compat';
import { debounce } from '@mui/material';

type InputValuesType = {
	contextAndObjectives: string;
	expectedOutcomes: string;
	workPerformedAndResults: string;
	projectPolicyRelevance: string;
	note: string;
};
interface PeriodicReportingSummaryProps {
	data: PeriodicReportingType;
	state: 'DRAFT' | 'VALIDATED';
	activeKey: string;
	inputValues: InputValuesType;
	setInputValues: React.Dispatch<React.SetStateAction<InputValuesType>>;
	isEnabledToView: boolean;
}

const PeriodicReportingSummary: React.FC<PeriodicReportingSummaryProps> = ({
	data,
	state,
	activeKey,
	inputValues,
	setInputValues,
	isEnabledToView,
}) => {
	const { pathname } = useLocation();
	const projectId = pathname.split('/')[2];

	const fields = [
		{
			name: 'contextAndObjectives',
			label: 'Contesto e principali obiettivi',
		},
		{
			name: 'expectedOutcomes',
			label: 'Lavoro svolto e principali risultati ottenuti',
		},
		{ name: 'workPerformedAndResults', label: 'Risultati attesi' },
		{
			name: 'projectPolicyRelevance',
			label: 'Policy rilevanti per il progetto',
		},
	];

	// const [inputValues, setInputValues] = useState({
	//   contextAndObjectives: data.contextAndObjectives || "",
	//   expectedOutcomes: data.expectedOutcomes || "",
	//   workPerformedAndResults: data.workPerformedAndResults || "",
	//   projectPolicyRelevance: data.projectPolicyRelevance || "",
	//   note: data.note || "",
	// });

	const [fieldsToSubmit, setFieldsToSubmit] = useState({
		contextAndObjectives: '',
		expectedOutcomes: '',
		workPerformedAndResults: '',
		projectPolicyRelevance: '',
		note: '',
	});

	const debouncedSetFieldsToSubmit = useRef(debounce((fieldsToSubmit) => setFieldsToSubmit(fieldsToSubmit), 500));

	useEffect(() => {
		debouncedSetFieldsToSubmit.current(inputValues);
	}, [inputValues]);

	const isModifiedRef = useRef(false);

	useEffect(() => {
		if (!isModifiedRef.current) return;
		if (activeKey !== 'summary') return;
		(async () => {
			try {
				await updateStatementByProjectIdAndStatementId(projectId, data.id, {
					statementTypeCode: 'PR',
					reportingStartDate: data.startDate,
					reportingEndDate: data.endDate,
					contextAndObjectives: fieldsToSubmit.contextAndObjectives,
					expectedOutcomes: fieldsToSubmit.expectedOutcomes,
					workPerformedAndResults: fieldsToSubmit.workPerformedAndResults,
					projectPolicyRelevance: fieldsToSubmit.projectPolicyRelevance,
					note: data.note,
				});
			} catch (error) {
				console.error('error', error);
			}
		})();
	}, [fieldsToSubmit, data, projectId, activeKey]);

	return (
		<Row>
			{fields.map((field) => (
				<Form.Group key={field.name} as={Col} xs={12} md={6} style={{ paddingInline: '20px', paddingBlock: '24px' }}>
					<Form.Label>{field.label}</Form.Label>
					<Form.Control
						as="textarea"
						rows={3}
						value={inputValues[field.name]}
						readOnly={!isEnabledToView}
						onChange={(event) => {
							setInputValues((prevIninputValues) => ({
								...prevIninputValues,
								[field.name]: event.target.value,
							}));
							if (!isModifiedRef.current) isModifiedRef.current = true;
						}}
					/>
				</Form.Group>
			))}
		</Row>
	);
};

export default PeriodicReportingSummary;
